import { Head } from '@inertiajs/react'
import { Wrench, Package, GraduationCap, ExternalLink, Download } from 'lucide-react'
import { MainLayout } from '@/components/layouts'
import { EditableContent } from '@/components/EditableContent'
import type { EditableContent as EditableContentType } from '@/types'

interface ToolboxProps {
  editable_banner: EditableContentType | null
}

export default function Toolbox({ editable_banner }: ToolboxProps) {
  return (
    <MainLayout
      title="Boite à outil"
    >
      <Head title="Boite à outil" />

      {/* Banner éditable (si existe) */}
      {editable_banner && (
        <EditableContent
          content={editable_banner}
          wrapperClassName="mb-8 -mt-8 -mx-4"
        />
      )}

      <div>
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Wrench className="w-8 h-8 text-tessan-primary" />
            <h1 className="font-heading text-3xl font-bold text-gray-900">
              Boite à outil
            </h1>
          </div>
          <p className="text-gray-500">
            Tous vos outils et ressources au même endroit
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {/* Kit de communication */}
          <section className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-tessan-cream rounded-lg flex items-center justify-center">
                  <Package className="w-6 h-6 text-tessan-green" />
                </div>
                <div>
                  <h2 className="font-heading text-xl font-bold text-gray-900">
                    Mon kit de communication à télécharger
                  </h2>
                  <p className="text-sm text-gray-500">
                    Téléchargez vos supports de communication
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <a
                href="https://7024058.fs1.hubspotusercontent-na1.net/hubfs/7024058/Kit%20de%20communication%20Tessan_TED%20fevrier.zip"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-tessan-green text-white rounded-lg hover:bg-tessan-green/90 transition-colors"
              >
                <Download className="w-4 h-4" />
                Télécharger le kit
                <ExternalLink className="w-3.5 h-3.5 ml-1 opacity-70" />
              </a>
            </div>
          </section>

          {/* Formation TED */}
          <section className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-tessan-cream rounded-lg flex items-center justify-center">
                  <GraduationCap className="w-6 h-6 text-tessan-green" />
                </div>
                <div>
                  <h2 className="font-heading text-xl font-bold text-gray-900">
                    Formation Télé expertise dermatologique
                  </h2>
                  <p className="text-sm text-gray-500">
                    Vidéo de formation onboarding Télé expertise dermatologique Tessan
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <video
                controls
                className="w-full rounded-lg"
                preload="metadata"
              >
                <source
                  src="https://7024058.fs1.hubspotusercontent-na1.net/hubfs/7024058/Video%20Onboarding%20TED%20Tessan%20-20251229.mp4"
                  type="video/mp4"
                />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
            </div>
          </section>
        </div>
      </div>
    </MainLayout>
  )
}
